import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items, defaultOpen = -1 }: { items: FaqItem[]; defaultOpen?: number }) {
  const [open, setOpen] = useState<number>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-label font-semibold ${
                      isOpen ? "bg-primary-600 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-heading text-base font-semibold text-foreground-900">{item.q}</span>
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                    isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-in-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}